import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { getCommaFormattedNumber } from '../../../utils/methods/stringMethods';
import { useTranslation } from 'react-i18next';

// Car price indicator
const CarRelistSection = ({ priceData }) => {
  const theme = useTheme();

  const { t } = useTranslation("carDetails")

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : '#fafafa',
        borderRadius: '9px',
        padding: '1.5rem',
        border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : '#e0e0e0'}`,
        mb: 4,
      }}
    >
      {/* Price indicator with connecting line */}
      <Box
        sx={{
          position: 'relative',
          margin: '0 auto',
          mb: 3,
          px: { xl: 2, md: 2, sm: 1, xs: 0 },
        }}
      >
        {/* Horizontal connecting line */}
        <Box
          sx={{
            position: 'absolute',
            width: 'calc(100% - 34%)',
            height: '2px',
            bgcolor: theme.palette.primary.main,
            top: { xl: '20px', xs: '15px' },
            left: '17%',
            zIndex: 0,
          }}
        />

        {/* Price points */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            position: 'relative',
            zIndex: 1,
          }}
        >
          {priceData.map((item, index) => (
            <Box
              key={index}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                flex: '1 1 0',
                minWidth: 0,
              }}
            >
              {/* Circle marker */}
              <Box
                sx={{
                  width: { xl: 40, md: 35, sm: 30, xs: 30 },
                  height: { xl: 40, md: 35, sm: 30, xs: 30 },
                  borderRadius: '50%',
                  bgcolor: theme.palette.primary.main,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mb: 1.5,
                  border: `4px solid ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : '#fafafa'}`,
                  zIndex: 1,
                }}
              />

              {/* Label and value inline */}
              <Box
                sx={{
                  display: { xl: 'flex', md: 'flex', sm: 'block', xs: 'block' },
                  alignItems: 'baseline',
                  gap: '0.35rem',
                  flexWrap: 'wrap',
                  justifyContent: 'center',
                }}
              >
                <Typography
                  sx={{
                    fontSize: { xl: `${20 / 16}rem`, md: `${18 / 16}rem`, sm: `${16 / 16}rem`, xs: `${16 / 16}rem` },
                    fontWeight: 600,
                    color: theme.palette.primary.main,
                    whiteSpace: 'nowrap',
                  }}
                >
                  {t(item.label)}:
                </Typography>
                <Typography
                  sx={{
                    fontSize: { xl: `${20 / 16}rem`, md: `${18 / 16}rem`, sm: `${16 / 16}rem`, xs: `${16 / 16}rem` },
                    fontWeight: 400,
                    color: theme.palette.mode === 'dark' ? '#b0b0b0' : '#333',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {item.value ? `$${getCommaFormattedNumber(item.value)}` : 'N/A'}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>

      {/* Footer message */}
      <Box
        sx={{
          mt: 2,
          pt: 3,
          borderTop: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : '#e8e8e8'}`,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            textAlign: 'center',
            fontWeight: 600,
            color: theme.palette.mode === 'dark' ? '#e0e0e0' : '#333',
            fontSize: `${20 / 16}rem`,
          }}
        >
          {t(`Our top priority is to sell your car.`)}
        </Typography>
      </Box>
    </Box>
  );
};

export default CarRelistSection;
